import { render } from "./stickers.vue?vue&type=template&id=490aadde&scoped=true"
import script from "./stickers.vue?vue&type=script&lang=js"
export * from "./stickers.vue?vue&type=script&lang=js"

import "./stickers.vue?vue&type=style&index=0&id=490aadde&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-490aadde"]])

export default __exports__